import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchCompanyPrincipal } from '@models/User';
import { useQueryClient } from '@tanstack/react-query';
import { EmailDuplicateError, FormError } from '@utils/errors';

export const usePatchCompanyPrincipal = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchCompanyPrincipal) => {
      const response = await companyApis.patch('/dashboard/company/{id}/owner/', {
        path: { id },
        body,
      });
      if (response[409]) {
        throw new EmailDuplicateError(
          `${response[409]?.email_duplicate_error?.join(',')} are already in use`,
        );
      }
      if (response[400]) {
        throw new FormError('PatchCompanyPrincipal', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/owner/`]);
      },
    },
  );
};
